import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { OfferServiceService } from 'src/app/admin/services/offers/offer-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
    selector: 'app-list-offers',
    templateUrl: './list-offers.component.html',
    styleUrls: ['./list-offers.component.scss'],
    standalone: false
})
export class ListOffersComponent implements OnInit {

  constructor(
    private offerService: OfferServiceService,
    private spinner: NgxSpinnerService,
    private userdata: UserdataService,
    private toast: ToastrService
  ) { }
  title = 'angular-datatables';

  offerList = [];
  id: any = '';
  temp: any = [];
  ColumnMode = ColumnMode;
  token: any = [];

  @ViewChild(DatatableComponent) myFilterTable: DatatableComponent | any;

  ngOnInit() {
    this.getOfferList()
  }

  /* ***********
  list Offer
  *********** */

  getOfferList() {
    this.spinner.show()
    this.offerService.allOffers({ userId: this.userdata.getId() }).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.offerList = res.data;
        this.temp = this.offerList;
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
      }
    );
  }

  /**
 * Update filter
 */
  updateFilter(event: any) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d: any) {
      return d.offer_name.toLowerCase().indexOf(val) !== -1 ||
        d.offer_display_name.toLowerCase().indexOf(val) !== -1 ||
        // d.user_type.toLowerCase().toString(val) !== -1 ||
        d.offer_discount.toString().indexOf(val) !== -1 ||
        d.offer_on.toString().indexOf(val) !== -1 || !val
    });

    // update the rows
    this.offerList = temp;
    // Whenever the filter changes, always go back to the first page
    this.myFilterTable.offset = 0;
  }

  /**Block/unblock Offer */

  public toggle($event: any, id: any, isValid: any) {
    //console.log(isValid)
    this.offerService.updateOffers({ _id: id, status: isValid, updatedId: this.userdata.getId(), updatedBy: this.userdata.getName() }).subscribe(
      (res: any) => {
        this.spinner.hide()
        this.toast.success(res.message, 'Success')
        this.getOfferList()
      },
      (err) => {
        this.spinner.hide()
        //console.log(err);
        this.toast.error(err.error.message, 'Error')
      }
    )
  }

}
